var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V15H0V0Z",
    fill: "#1EB53A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V7.5H0V0Z",
    fill: "#0099B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8H30V10.2H0V4.8Z",
    fill: "#CE1126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.1H30V9.9H0V5.1Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 4.2C5.19411 4.2 6 3.39411 6 2.4C6 1.40589 5.19411 0.6 4.2 0.6C3.20589 0.6 2.4 1.40589 2.4 2.4C2.4 3.39411 3.20589 4.2 4.2 4.2Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 4.2C5.79411 4.2 6.6 3.39411 6.6 2.4C6.6 1.40589 5.79411 0.6 4.8 0.6C3.80589 0.6 3 1.40589 3 2.4C3 3.39411 3.80589 4.2 4.8 4.2Z",
    fill: "#0099B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16 3.48L8.04875 3.82238L8.21994 3.878",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16 3.48L8.27125 3.82238L8.10006 3.878",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50238 3.72875H8.14238V3.90875",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50238 3.72875L8.21113 3.94036L8.10533 3.79473",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81762 3.72875L8.10887 3.94036L8.21467 3.79473",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81762 3.72875H8.17762V3.90875",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3716 4.13125L8.26036 3.78887L8.08917 3.84449",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3716 4.13125L8.08036 3.91964L8.18616 3.77402",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9484 4.13125L8.23964 3.91964L8.13384 3.77402",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9484 4.13125L8.05964 3.78887L8.23083 3.84449",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16 2.04L8.04875 2.38238L8.21994 2.438",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16 2.04L8.27125 2.38238L8.10006 2.438",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50238 2.28875H8.14238V2.46875",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50238 2.28875L8.21113 2.50036L8.10533 2.35473",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81762 2.28875L8.10887 2.50036L8.21467 2.35473",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81762 2.28875H8.17762V2.46875",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3716 2.69125L8.26036 2.34887L8.08917 2.40449",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3716 2.69125L8.08036 2.47964L8.18616 2.33402",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9484 2.69125L8.23964 2.47964L8.13384 2.33402",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9484 2.69125L8.05964 2.34887L8.23083 2.40449",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16 0.6L8.04875 0.94238L8.21994 0.998003",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16 0.6L8.27125 0.94238L8.10006 0.998003",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50238 0.848754H8.14238V1.02875",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50238 0.848754L8.21113 1.06036L8.10533 0.914733",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81762 0.848754L8.10887 1.06036L8.21467 0.914733",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81762 0.848754H8.17762V1.02875",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3716 1.25125L8.26036 0.908866L8.08917 0.964489",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3716 1.25125L8.08036 1.03964L8.18616 0.89402",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9484 1.25125L8.23964 1.03964L8.13384 0.89402",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9484 1.25125L8.05964 0.908866L8.23083 0.964489",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 3.48L9.48875 3.82238L9.65994 3.878",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 3.48L9.71125 3.82238L9.54006 3.878",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94238 3.72875H9.58238V3.90875",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94238 3.72875L9.65113 3.94036L9.54533 3.79473",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25762 3.72875L9.54887 3.94036L9.65467 3.79473",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25762 3.72875H9.61762V3.90875",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8116 4.13125L9.70036 3.78887L9.52917 3.84449",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8116 4.13125L9.52036 3.91964L9.62616 3.77402",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3884 4.13125L9.67964 3.91964L9.57384 3.77402",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3884 4.13125L9.49964 3.78887L9.67083 3.84449",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 2.04L9.48875 2.38238L9.65994 2.438",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 2.04L9.71125 2.38238L9.54006 2.438",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94238 2.28875H9.58238V2.46875",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94238 2.28875L9.65113 2.50036L9.54533 2.35473",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25762 2.28875L9.54887 2.50036L9.65467 2.35473",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25762 2.28875H9.61762V2.46875",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8116 2.69125L9.70036 2.34887L9.52917 2.40449",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8116 2.69125L9.52036 2.47964L9.62616 2.33402",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3884 2.69125L9.67964 2.47964L9.57384 2.33402",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3884 2.69125L9.49964 2.34887L9.67083 2.40449",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0.6L9.48875 0.94238L9.65994 0.998003",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0.6L9.71125 0.94238L9.54006 0.998003",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94238 0.848754H9.58238V1.02875",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94238 0.848754L9.65113 1.06036L9.54533 0.914733",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25762 0.848754L9.54887 1.06036L9.65467 0.914733",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25762 0.848754H9.61762V1.02875",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8116 1.25125L9.70036 0.908866L9.52917 0.964489",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8116 1.25125L9.52036 1.03964L9.62616 0.89402",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3884 1.25125L9.67964 1.03964L9.57384 0.89402",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3884 1.25125L9.49964 0.908866L9.67083 0.964489",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 3.48L10.9288 3.82238L11.0999 3.878",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 3.48L11.1512 3.82238L10.9801 3.878",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3824 3.72875H11.0224V3.90875",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3824 3.72875L11.0911 3.94036L10.9853 3.79473",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 3.72875L10.9889 3.94036L11.0947 3.79473",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 3.72875H11.0576V3.90875",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2516 4.13125L11.1404 3.78887L10.9692 3.84449",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2516 4.13125L10.9604 3.91964L11.0662 3.77402",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 4.13125L11.1196 3.91964L11.0138 3.77402",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 4.13125L10.9396 3.78887L11.1108 3.84449",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 2.04L10.9288 2.38238L11.0999 2.438",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 2.04L11.1512 2.38238L10.9801 2.438",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3824 2.28875H11.0224V2.46875",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3824 2.28875L11.0911 2.50036L10.9853 2.35473",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 2.28875L10.9889 2.50036L11.0947 2.35473",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 2.28875H11.0576V2.46875",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2516 2.69125L11.1404 2.34887L10.9692 2.40449",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2516 2.69125L10.9604 2.47964L11.0662 2.33402",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 2.69125L11.1196 2.47964L11.0138 2.33402",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 2.69125L10.9396 2.34887L11.1108 2.40449",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 0.6L10.9288 0.94238L11.0999 0.998003",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 0.6L11.1512 0.94238L10.9801 0.998003",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3824 0.848754H11.0224V1.02875",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3824 0.848754L11.0911 1.06036L10.9853 0.914733",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 0.848754L10.9889 1.06036L11.0947 0.914733",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 0.848754H11.0576V1.02875",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2516 1.25125L11.1404 0.908866L10.9692 0.964489",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2516 1.25125L10.9604 1.03964L11.0662 0.89402",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 1.25125L11.1196 1.03964L11.0138 0.89402",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 1.25125L10.9396 0.908866L11.1108 0.964489",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28 3.48L5.16875 3.82238L5.33994 3.878",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28 3.48L5.39125 3.82238L5.22006 3.878",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62238 3.72875H5.26238V3.90875",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62238 3.72875L5.33113 3.94036L5.22533 3.79473",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93762 3.72875L5.22886 3.94036L5.33467 3.79473",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93762 3.72875H5.29762V3.90875",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4916 4.13125L5.38036 3.78887L5.20917 3.84449",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4916 4.13125L5.20036 3.91964L5.30616 3.77402",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0684 4.13125L5.35964 3.91964L5.25384 3.77402",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0684 4.13125L5.17964 3.78887L5.35083 3.84449",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72 3.48L6.60875 3.82238L6.77994 3.878",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72 3.48L6.83125 3.82238L6.66006 3.878",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06238 3.72875H6.70238V3.90875",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06238 3.72875L6.77113 3.94036L6.66533 3.79473",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37762 3.72875L6.66887 3.94036L6.77467 3.79473",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37762 3.72875H6.73762V3.90875",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9316 4.13125L6.82036 3.78887L6.64917 3.84449",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9316 4.13125L6.64036 3.91964L6.74616 3.77402",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5084 4.13125L6.79964 3.91964L6.69384 3.77402",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5084 4.13125L6.61964 3.78887L6.79083 3.84449",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72 2.04L6.60875 2.38238L6.77994 2.438",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72 2.04L6.83125 2.38238L6.66006 2.438",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06238 2.28875H6.70238V2.46875",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06238 2.28875L6.77113 2.50036L6.66533 2.35473",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37762 2.28875L6.66887 2.50036L6.77467 2.35473",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37762 2.28875H6.73762V2.46875",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9316 2.69125L6.82036 2.34887L6.64917 2.40449",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9316 2.69125L6.64036 2.47964L6.74616 2.33402",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5084 2.69125L6.79964 2.47964L6.69384 2.33402",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5084 2.69125L6.61964 2.34887L6.79083 2.40449",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.e26d289fc71c9aedbc0454eeb8b88f4f.svg";
export { ForwardRef as ReactComponent };